(function () {
    'use strict';

    angular.module("imApp").factory("ohDispatchesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1697,
                    parameters: parms || {}
                });
            },
            listDispatches: function (parms) {
                return $ihttp.post({
                    method: 1698,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
